const fp_onDatePickerReady = (selectedDates, dateStr, instance, locale) => {
  // console.log('fp_onDatePickerReady', selectedDates, dateStr, instance, locale);
  // add labels to next/prev month buttons
  const $prevMonth = instance.calendarContainer.querySelector('.flatpickr-prev-month');
  const $nextMonth = instance.calendarContainer.querySelector('.flatpickr-next-month');

  if ($prevMonth) {
    $prevMonth.setAttribute('aria-label', locale === 'en' ? 'Previous month' : 'Mois précédent');
    $prevMonth.setAttribute('tabindex', 0);
    $prevMonth.setAttribute('role', 'button');
    $prevMonth.addEventListener('keydown', e => {
       if (e.key === 'Enter' || e.key === ' ') {
         e.preventDefault();
         $prevMonth.click();
       }
     });
  }

  if ($nextMonth) {
    $nextMonth.setAttribute('aria-label', locale === 'en' ? 'Next month' : 'Mois suivant');
    $nextMonth.setAttribute('tabindex', 0);
    $nextMonth.setAttribute('role', 'button');
    $nextMonth.addEventListener('keydown', e => {
       if (e.key === 'Enter' || e.key === ' ') {
         e.preventDefault();
         $nextMonth.click();
       }
     });
  }

  // hide month from screen reader
  let $month = instance.calendarContainer.querySelector('.flatpickr-month');
  if ($month) {
    $month.setAttribute('aria-hidden', 'true');
  }

  // hide weekdays from screen reader
  let $weekdays = instance.calendarContainer.querySelector('.flatpickr-weekdays');
  if ($weekdays) {
    $weekdays.setAttribute('aria-hidden', 'true');
  }

  // set role of days grid
  let $grid = instance.calendarContainer.querySelector('.flatpickr-days');
  if ($grid) {
    $grid.setAttribute('role', 'grid');
  }

  // aria-label for current month and year
  const currentMonth = instance.currentMonth + 1;
  const year = instance.currentYear;
  instance.calendarContainer.setAttribute('aria-label', `Calendar for ${currentMonth}/${year}`);

  window.requestAnimationFrame(() => {
    fp_onMonthChange(instance, locale);
  });

  // add instructions
  const $instructions = document.createElement('p');
  $instructions.id = `datepicker-instructions-${ Math.floor(Math.random() * 999) }`;
  $instructions.className = 'sr-only';
  //$instructions.style = 'color: green;';
  if (instance.calendarContainer.classList.contains('rangeMode')) {
    $instructions.textContent = locale === 'en' ? 'Use arrow keys to navigate dates. Press Enter to select the start date, then navigate and press Enter again to select the end date. Press Escape to close the calendar. Once selected navigate to the set button to confirm selection and apply filter.' : 'Utilisez les flèches pour parcourir les dates. Appuyez sur Entrée pour sélectionner la date de début, puis naviguez et appuyez à nouveau sur Entrée pour sélectionner la date de fin. Appuyez sur Échap pour fermer le calendrier. Une fois sélectionné, accédez au bouton « Définir » pour confirmer la sélection et appliquer le filtre.';
  } else {
     $instructions.textContent = locale === 'en' ? 'Use arrow keys to navigate dates. Press Enter to select date. Press Escape to close the calendar.' : 'Utilisez les flèches pour parcourir les dates. Appuyez sur Entrée pour sélectionner une date. Appuyez sur Échap pour fermer le calendrier.';
  }
  instance.calendarContainer.prepend($instructions);
  instance.calendarContainer.setAttribute('aria-describedby', $instructions.id);
}

const fp_onDateChange = (selectedDates, dateStr, instance, locale) => {
  // console.log('fp_onDateChange', selectedDates, dateStr, instance, locale);
  // set aria-selected
  const $days = instance.calendarContainer.querySelectorAll('.flatpickr-day');
  $days.forEach($btn => {
    if ($btn.classList.contains('selected') || $btn.classList.contains('inRange')) {
      $btn.setAttribute('aria-selected', 'true');
    } else {
      $btn.removeAttribute('aria-selected');
    }

    if ($btn.classList.contains('today')) {
      $btn.setAttribute('aria-current', 'true');
    } else {
      $btn.removeAttribute('aria-current');
    }

    if ($btn.classList.contains('startRange')) {
      $btn.setAttribute('aria-label', `${locale === 'en' ? 'Start date:' : 'Date de début:'} ${$btn.getAttribute('aria-label')}`);
    }
    if ($btn.classList.contains('endRange')) {
      $btn.setAttribute('aria-label', `${locale === 'en' ? 'End date:' : 'Date de fin:'} ${$btn.getAttribute('aria-label')}`);
    }
  });

  fp_updateLiveRegion(instance.calendarContainer, locale, dateStr, 'date');
};

const fp_updateLiveRegion = ($node, locale, str, type) => {
  // console.log('fp_updateLiveRegion', $node, locale, str, type);
  // find live region
  let $liveRegion = $node.querySelector('[aria-live]');
  // add if none
  if (!$liveRegion) {
    $liveRegion = document.createElement('p');
    $liveRegion.className = 'sr-only';
    //$liveRegion.style = 'color: red;';
    $liveRegion.setAttribute('aria-live', 'polite');
    $node.prepend($liveRegion);
  }
  // update
  if (str) {
    let typeStr = locale === 'en' ? 'Date selected: ' : 'Date sélectionnée: ';
    if (type === 'hour') {
      typeStr = locale === 'en' ? 'Time selected: ' : 'Heure sélectionnée: ';
    }
    if (type === 'monthChange') {
      typeStr = locale === 'en' ? 'Showing: ' : 'Montrant: ';
    }
    $liveRegion.textContent = `${typeStr} ${str}`;
  } else {
    $liveRegion.textContent = '';
  }
}

const fp_onDayCreate = (dObj, dStr, fp, dayElem) => {
  dayElem.setAttribute('role', 'gridcell');
}

const fp_onMonthChange = (instance, locale) => {
  // console.log('fp_onMonthChange', instance, locale);
  const month = instance.l10n.months.longhand[instance.currentMonth];
  const year = instance.currentYear;
  let str = `${month} ${year}`;

  if (instance.monthElements.length === 2) {
    // Get the second month's number and year
    let secondMonth = instance.currentMonth + 1;
    let secondYear = instance.currentYear;

    if (secondMonth > 11) {
      secondMonth = 0; // January
      secondYear += 1; // Next year
    }

    const month2 = instance.l10n.months.longhand[secondMonth];
    str += ` - ${month2} ${secondYear}`;
  }

  fp_updateLiveRegion(instance.calendarContainer, locale, str, 'monthChange');

  const $firstDay = instance.calendarContainer.querySelector('.flatpickr-day.startRange') || instance.calendarContainer.querySelector('.flatpickr-day.selected') || instance.calendarContainer.querySelector('.flatpickr-day.today:not(.flatpickr-disabled)') || instance.calendarContainer.querySelector('.flatpickr-day.selected') || instance.calendarContainer.querySelector('.flatpickr-day:not(.flatpickr-disabled)');
  if ($firstDay) {
    $firstDay.setAttribute('tabindex', 0);
  } else {
    instance.calendarContainer.querySelector('.flatpickr-day');
    instance.calendarContainer.querySelector('.flatpickr-prev-month').focus();
  }
}


export { fp_onDatePickerReady, fp_onDateChange, fp_updateLiveRegion, fp_onDayCreate, fp_onMonthChange };
